import React, { useState } from "react";
import { Col, Container, Form, Row, Button } from "react-bootstrap";
import { useRegisterUserMutation } from "../services/appApi";
import { Link, useNavigate } from "react-router-dom";
import "./Signup.css";
import botImg from "../assets/bot.jpeg";
import SingupImage from "../assets/SignupImage.png";

function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [registerUser, { isLoading }] = useRegisterUserMutation();
  const navigate = useNavigate();
  // image upload states
  const [image, setImage] = useState(null);
  const [upladingImg, setUploadingImg] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  // Local error state — captures all error types including 429 rate limit
  const [errorMsg, setErrorMsg] = useState("");

  function validateImg(e) {
    const file = e.target.files[0];
    if (file.size >= 1048576) {
      return alert("Max file size is 1mb");
    } else {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  }

  async function uploadImage() {
    const data = new FormData();
    data.append("file", image);
    data.append("upload_preset", "jf1mzqtl");
    try {
      setUploadingImg(true);
      let res = await fetch(
        "https://api.cloudinary.com/v1_1/dzb4vu4sn/image/upload",
        {
          method: "post",
          body: data,
        }
      );
      const urlData = await res.json();
      setUploadingImg(false);
      return urlData.secure_url;
    } catch (error) {
      setUploadingImg(false);
      console.log(error);
    }
  }

  async function handleSignup(e) {
    e.preventDefault();
    setErrorMsg(""); // clear previous errors
    if (!image) return alert("Please upload your profile picture");
    const url = await uploadImage(image);
    // Register the user — sends OTP email, does NOT log in yet
    registerUser({ name, email, password, picture: url }).then(({ data, error: reqError }) => {
      if (data && data.success) {
        // Go to OTP verification page, passing the email so the page knows where the code was sent
        navigate("/verify-email", { state: { email: data.email } });
      } else if (reqError) {
        // Extract a human-readable string from the RTK Query error object
        const msg =
          reqError?.data?.error ||
          reqError?.data ||
          "Something went wrong. Please try again.";
        setErrorMsg(typeof msg === "string" ? msg : JSON.stringify(msg));
      }
    });
  }

  return (
    <div className="Signup_MainContainer">
      <Container>
        <Row>
          <Col
            md={7}
            className="d-flex align-items-center justify-content-center flex-direction-column"
          >
            <Form
              style={{ width: "80%", maxWidth: 500 }}
              onSubmit={handleSignup}
            >
              <h1 className="text-center">Create account</h1>
              <div className="signup-profile-pic__container">
                <img
                  src={imagePreview || botImg}
                  className="signup-profile-pic"
                />
                <label htmlFor="image-upload" className="image-upload-label">
                  <i className="fas fa-plus-circle add-picture-icon"></i>
                </label>
                <input
                  type="file"
                  id="image-upload"
                  hidden
                  accept="image/png, image/jpeg"
                  onChange={validateImg}
                />
              </div>
              {/* Show any error inline — 400, 409 conflict, 429 rate limit, etc. */}
              {errorMsg && <p className="alert alert-danger">{errorMsg}</p>}
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Your name"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
                <Form.Text className="text-muted">
                  We'll never share your email with anyone else.
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                />
              </Form.Group>
              <Button variant="primary" type="submit" disabled={upladingImg || isLoading}>
                {upladingImg || isLoading ? "Signing you up..." : "Signup"}
              </Button>
              <div className="py-4">
                <p className="text-center">
                  Already have an account ? <Link to="/login">Login</Link>
                </p>
                <img id="SingupImage" src={SingupImage} />
              </div>
            </Form>
          </Col>
          <Col md={5} className="signup__bg"></Col>
        </Row>
      </Container>
    </div>
  );
}

export default Signup;
